import isPropValid from '@emotion/is-prop-valid';

const shouldForwardProp = (propName, target) =>
  typeof target === 'string' ? isPropValid(propName) : true;

export default shouldForwardProp;
